/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import SeguimientoReembolsos from "./seguimientoReembolsos.cmpt";
import ReactResizeDetector from 'react-resize-detector';
import { iframeResizer as iframeResizerLib } from 'iframe-resizer';
import { debounce } from 'underscore';
import SeguimientoSiniestro  from "./seguimientoSiniestro/seguimientoSiniestro.cmpt"
import ConsultaCfdi from "../pago-deducible-auto/consulta-cfdi/consultaCfdi.cmpt";
import EmitirCfdi from "../pago-deducible-auto/emitir-cfdi/emitirCfdi.cmpt";

import { setCfdi,estadoInicial } from "../pago-deducible-auto/pagoDeducibleAuto-actions";
import { connect } from "react-redux";
import { servicios } from "../properties";

const seguimientoAlSiniestro = "Seguimiento al siniestro";

const mapState = (state) => {
	return {
		cfdi: state.pagoDeducibleAutos.cfdi,
		refreshToken: state.global.refreshToken,
	};
};

const mapDispatch = (dispatch) => {
	return {
		addEvento: (evento) => {
			dispatch({ type: "SINIESTROS_SET_EVENT", evento: evento });
		},
		onSetCfdi: (optCfdi) => {
			dispatch(setCfdi(optCfdi));
		},
		onEstadoInicialCfdi: () => {
			dispatch(estadoInicial());
		}
	};
};
class SeguimientoSiniestros extends React.Component {
  state = {
  	showReparacion: true,
  	showAutoservicio: false,
  	showRembolso: false,
  	tabSelect: [],
  	secondMenuTitle: seguimientoAlSiniestro,
  	arrowOrange: [
  		require("../img/arrow-down.svg"),
  		require("../img/arrow-up.svg"),
  	],
  	arrowIndexTabs: 0,
  	mobileTabs: false,
  	lat: "0.0",
  	long: "0.0",
  	pagoVentanilla: true,
  	optionCfdi: "",
  	showCFDI: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {  	
  	const optionCfdi = nextProps.cfdi;
  	if (optionCfdi !== "") {
  		this.setState({
  			showCFDI: true,
  			showReparacion: false,
  			optionCfdi,
  		});
  	} else {
  		this.setState({
  			showCFDI: false,
  			optionCfdi: "",
  		});
  	}
  }

  componentDidMount() {
  	$("#returnPageSiniestros").hide();
  	if (navigator.geolocation) {
  		navigator.geolocation.getCurrentPosition((position) => {
  			this.setState({
  				lat: position.coords.latitude,
  				long: position.coords.longitude,
  			});
  		});
  	}
  }

  selectTab = (sTab) => {  	
  	event.preventDefault();
  	var temporal = {
  		secondMenuTitle: sTab[0],
  		showReparacion: false,
  		showAutoservicio: false,
  		showRembolso: false,
  		tabSelect: sTab,
  		showCFDI: false,
  		optionCfdi: "",
  	};
	if(temporal.secondMenuTitle !== 'CFDI'){
		this.props.onEstadoInicialCfdi();
	}
  	this.props.addEvento(temporal.secondMenuTitle);
  	switch (temporal.secondMenuTitle) {
  	case seguimientoAlSiniestro:
  		temporal.showReparacion = true;
  		break;
  	case "Seguimiento a la reparación":
  		temporal.showReparacion = true;
  		break;
  	case "Seguimiento a reembolsos":
  		temporal.showRembolso = true;
  		break;
  	case "Autoservicio":
  		temporal.showAutoservicio = true;
  		break;
  	case "CFDI":
  		temporal.showCFDI = true;
  		temporal.optionCfdi = "Consulta";
  		break;
  	default:
  		temporal.showReparacion = true;
  		break;
  	}
  	this.setState(temporal);
  	this.showMobileTabs();
  };

  showMobileTabs = () => {
  	var arrowIndexTabs;
  	if (this.state.arrowIndexTabs == 1) {
  		arrowIndexTabs = 0;
  	} else if (this.state.arrowIndexTabs == 0) {
  		arrowIndexTabs = 1;
  	}

  	this.setState({
  		mobileTabs: !this.state.mobileTabs,
  		arrowIndexTabs: arrowIndexTabs,
  	});
  };

  sitioExterno = () => {
	  const downloadUrl = URL.createObjectURL(servicios.utilerias.seguimientoJuridico);
	  var createA = document.createElement('a');
	  createA.setAttribute('target', '_blank')
	  createA.setAttribute('href', downloadUrl);
	  createA.click();
  };

  iframeResizer = [];

  componentWillUnmount() {
  	if (this.iframeResizer.length && this.iframeResizer[0].iFrameResizer) {
  		this.iframeResizer[0].iFrameResizer.close();
  	}
  }

  resizeIframe = () => {
  	const { iFrame } = this.refs;
  	if (!iFrame){
		return;
	}
  	this.iframeResizer = iframeResizerLib(
  		{
  			log: false,
  			heightCalculationMethod: "taggedElement",
  			autoResize: true,
  			minHeight: 500,
  			scrolling: "auto",
  		},
  		iFrame
  	);
  };

  onLoadIframe = () => {
  	this.resizeIframe();
  };

  onResize = debounce(() => {
  	if (this.iframeResizer.length && this.iframeResizer[0].iFrameResizer) {
  		this.iframeResizer[0].iFrameResizer.resize();
  	}
  }, 100);

  regresarEmitir = () => {
  	this.setState({
  		showCFDI: true,
  	});
  	this.props.onSetCfdi("Consulta");
  };

  render() {
  	const propsComunes = {
  		ref: "iFrame",
  		frameBorder: "0",
  		width: "100%",
  		value: "web",
  		id: "web",
  		className: "frame-autoservicios",
  		"data-origen": "Autoservicios",
  		"data-height": window.innerHeight,
  		src: `${servicios.misTramites.autos.portalAutoservicioPag}?jwt=${this.props.refreshToken}&origen=SCL&lat=${this.state.lat}&long=${this.state.long}`,
  	};

  	return (
  		<div>
  			<div className="tercer-menu text-center hide-mobile">
  				<img
  					onClick={this.selectTab.bind(this, this.tabSelect)}
  					className="detalle-back-arrow hide"
  					src={require("../img/arrow-back.svg")}
  					id="returnPageSiniestros"
  				/>
  				<ul className="clearfix">
  					<li>
  						<button
  							disabled={this.state.showReparacion}
  							className={this.state.showReparacion ? "active" : ""}
  							onClick={this.selectTab.bind(this, [
  								seguimientoAlSiniestro,
  							])}
  						>
                {seguimientoAlSiniestro}
  						</button>
  					</li>
  					<li>
  						<button
  							disabled={this.state.showAutoservicio}
  							className={this.state.showAutoservicio ? "active" : ""}
  							onClick={this.selectTab.bind(this, ["Autoservicio"])}
  						>
                Pago de Pérdidas Totales y Reembolsos
  						</button>
  					</li>
  					{/* <li>
						<button disabled={this.state.showRembolso} className={this.state.showRembolso ? "active" : ""} onClick={this.selectTab.bind(this, ["Seguimiento a reembolsos"])}>Seguimiento a reembolsos</button>
					</li> */}
  					<li>
  						<button onClick={this.sitioExterno}>
                Asistencia Legal y Fianza de Autos
  						</button>
  					</li>
  					<li>
  						<button
  							disabled={this.state.showCFDI}
  							className={this.state.showCFDI ? "active" : ""}
  							onClick={this.selectTab.bind(this, ["CFDI"])}
  						>
                CFDI
  						</button>
  					</li>
  				</ul>
  			</div>
  			<div className="second-menu text-center show-mobile">
  				<div className="second-menu-select-mobile">
  					<p onClick={this.showMobileTabs}>
  						{this.state.secondMenuTitle}{" "}
  						<img
  							src={this.state.arrowOrange[this.state.arrowIndexTabs]}
  						></img>
  					</p>
  					{this.state.mobileTabs && (
  						<ul>
  							<li
  								onClick={this.selectTab.bind(this, [
  									seguimientoAlSiniestro,
  								])}
  							>
  								<button disabled={this.state.showReparacion}>
                    {seguimientoAlSiniestro}
  								</button>
  								<div
  									className={this.state.showReparacion ? "active" : ""}
  								></div>
  							</li>
  							<li>
  								<button
  									disabled={this.state.showAutoservicio}
  									className={this.state.showAutoservicio ? "active" : ""}
  									onClick={this.selectTab.bind(this, ["Autoservicio"])}
  									style={{ width: "auto" }}
  								>
                    Pago de Pérdidas Totales y Reembolsos
  								</button>
  							</li>
  							{/* <li onClick={this.selectTab.bind(this, ["Seguimiento a reembolsos"])}>
								<button disabled={this.state.showRembolso}>Seguimiento a reembolsos</button>
								<div className={this.state.showRembolso ? "active" : ""}></div>
							</li> */}
  							<li>
  								<button
  									disabled={this.state.showCFDI}
  									className={this.state.showCFDI ? "active" : ""}
  									onClick={this.selectTab.bind(this, ["CFDI"])}
  								>
                    CFDI
  								</button>
  							</li>
  						</ul>
  					)}
  				</div>
  			</div>
  			{this.state.showReparacion && <SeguimientoSiniestro />}
  			{this.state.showAutoservicio && (
  				<div>
  					<ReactResizeDetector handleWidth onResize={this.onResize} />
  					<iframe
  						{...propsComunes}
  						onLoad={this.onLoadIframe}
  						name={`${this.props.tid}#altaSeguimiento`}
  					/>
  				</div>
  			)}
  			{this.state.showRembolso && <SeguimientoReembolsos />}
  			{this.state.showCFDI && this.state.optionCfdi === "Consulta" && (
  				<ConsultaCfdi />
  			)}
  			{this.state.showCFDI && this.state.optionCfdi === "Emitir" && (
  				<EmitirCfdi handleRegresar={() => this.regresarEmitir()} />
  			)}
  		</div>
  	);
  }
}


export default connect(mapState, mapDispatch)(SeguimientoSiniestros);



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/seguimientoSiniestros.cmpt.js